import axios from 'axios';
import { getAuthHeaders } from '../utils/authUtils';

const base = () => `${process.env.REACT_APP_API_URL}/api/v3/posts`;
const config = () => ({ headers: { ...getAuthHeaders(), 'Content-Type': 'application/json' } });

/**
 * Social media posts (rev6 Part 5). A post's work happens on its tasks; this is making and editing
 * the post, and saving its boxes. Errors keep the server's { code, message } body.
 */
const PostService = {
    create: async (body) => (await axios.post(base(), body, config())).data,
    get: async (id) => (await axios.get(`${base()}/${id}`, config())).data,
    /** Returns { dubbingLeft, notSentBack, sentBack }: the languages that change didn't reach, and those that went back. */
    edit: async (id, body) => (await axios.patch(`${base()}/${id}`, body, config())).data,
    remove: async (id) => axios.delete(`${base()}/${id}`, config()),
    restore: async (id) => axios.post(`${base()}/${id}/restore`, {}, config()),
    deleted: async () => (await axios.get(`${base()}/deleted`, config())).data,
    /** { videoId, title, languageKeys }, for the Video box. */
    video: async (videoId) => (await axios.get(`${base()}/video/${videoId}`, config())).data,
    lastAssignees: async (languages) =>
        (await axios.get(`${base()}/last-assignees`, { ...config(), params: { languages: languages.join(',') } })).data,
    addLanguage: async (id, body) => (await axios.post(`${base()}/${id}/languages`, body, config())).data,
    removeLanguage: async (id, lang, confirmed) =>
        axios.delete(`${base()}/${id}/languages/${lang}`, { ...config(), params: { confirmed } }),
    /** body: { date, shown: { languageKey: date }, allLanguages }. applied false means ask about result.languages. */
    setPostingDate: async (id, body) => (await axios.post(`${base()}/${id}/posting-date`, body, config())).data,
    saveBox: async (id, lang, body) => (await axios.patch(`${base()}/${id}/languages/${lang}`, body, config())).data,
};

export default PostService;
